import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

// One codebase, three builds (security split 2026-10-21). REACT_APP_PORTAL is
// fixed at build time, so webpack drops the other apps from the bundle — the
// public site does not contain the admin screens.
let App;
if (process.env.REACT_APP_PORTAL === "public") {
  App = require("./AppPublic").default;
} else if (process.env.REACT_APP_PORTAL === "admin") {
  App = require("./AppAdmin").default;
} else {
  App = require("./App").default;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
